(function(app, ng) {

    app.component("addEvent",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/Components/AddEvent/add-event.component.html",
            controller: addEventController,
            bindings: {
                selectedYear: "<",
                startDate: "<",
                eventTypes: "<",
                eventCounts: "<",
                recomendations: "<",
                user: "<",
                onEventAddedFn: "&"
            }
        });

    addEventController.$inject = ["amplitudeService", "$mdDialog", "figToaster", "colorCodeEventTypes"];
    function addEventController(amplitudeService, $mdDialog, figToaster, colorCodeEventTypes) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                toggleCalSideNav: toggleCalSideNav,
                openAddEvent: openAddEvent,
                ui: {}
            });

        function toggleCalSideNav() {
            $ctrl.ui.CalSideNavIsOpen = !$ctrl.ui.CalSideNavIsOpen;
        }

        function openAddEvent(eventType) {
            if (eventType.Id === "FIG Event")
                return false;
            return $mdDialog.show({
                    templateUrl: "App/Tools/MarketingTracker/Calendar/AddEvent/addevent-template.html",
                    controller: "addEventController",
                    controllerAs: "$ctrl",
                    locals: {
                        eventType: eventType,
                        user: $ctrl.user,
                        selectedYear: $ctrl.selectedYear || (new Date()).getFullYear(),
                        startDate: $ctrl.startDate
                    },
                    bindToController: true
                })
                .then(function(response) {
                    amplitudeService.logClickEvent('Added Event');
                    $ctrl.toggleCalSideNav();
                    $ctrl.onEventAddedFn({ response: response });
                    return figToaster.showSimple("Event added.", "top", "is-success");
                });
            //.catch(function (error) {
            //    //console.log("Error: " + error.data);
            //    message = "There was a problem adding your event. Please try again shortly.";
            //    toastClass = "is-error";
            //})
            //.finally(function () {
            //    return figToaster.showSimple(message, "top", toastClass);
            //});
        }

        $ctrl.$onChanges = function (changes) {
            if (changes.eventTypes);
                $ctrl.eventTypes = colorCodeEventTypes.addCodeToEvent($ctrl.eventTypes);
        };
    }

})(window.app, window.angular); //jshint ignore:line